if (!customElements.get('custom-featured-collection')) {
  customElements.define('custom-featured-collection', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-custom-featured-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-custom-featured-panel]'));
      this.status = this.querySelector('[data-custom-featured-status]');
      this.sliderControls = this.querySelector('[data-custom-featured-slider-controls]');
      this.previous = this.querySelector('[data-custom-featured-previous]');
      this.next = this.querySelector('[data-custom-featured-next]');
      this.activeIndex = Math.max(this.tabs.findIndex((tab) => tab.classList.contains('is-active')), 0);

      this.onTabClick = (event) => {
        const tab = event.currentTarget;
        this.showTab(Number(tab.dataset.customFeaturedTab), true, true);
      };

      this.onTabKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.showTab(nextIndex, true, true);
      };

      this.onResize = () => this.updateArrows();
      this.onPrevious = () => this.scrollActivePanel(-1);
      this.onNext = () => this.scrollActivePanel(1);
      this.onBlockSelect = (event) => {
        const panel = event.target.closest('[data-custom-featured-panel]');
        if (!panel || !this.contains(panel)) return;
        const index = this.panels.indexOf(panel);
        if (index > -1) this.showTab(index, false, false);
      };

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick);
        tab.addEventListener('keydown', this.onTabKeydown);
      });

      this.panels.forEach((panel) => this.bindPanel(panel));
      this.previous?.addEventListener('click', this.onPrevious);
      this.next?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.showTab(this.activeIndex, false, false);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.onTabClick);
        tab.removeEventListener('keydown', this.onTabKeydown);
      });

      this.panels?.forEach((panel) => this.unbindPanel(panel));
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    bindPanel(panel) {
      const track = panel.querySelector('[data-custom-featured-products]');
      if (!track) return;

      const update = () => this.updatePanelArrows(panel);

      panel.customFeaturedHandlers = { update };
      track.addEventListener('scroll', update, { passive: true });
    }

    unbindPanel(panel) {
      const handlers = panel.customFeaturedHandlers;
      if (!handlers) return;
      const track = panel.querySelector('[data-custom-featured-products]');
      track?.removeEventListener('scroll', handlers.update);
      delete panel.customFeaturedHandlers;
    }

    scrollActivePanel(direction) {
      const panel = this.panels[this.activeIndex];
      const track = panel?.querySelector('[data-custom-featured-products]');
      if (!track) return;
      track.scrollBy({ left: direction * this.getScrollStep(track), behavior: 'smooth' });
    }

    showTab(index, focusTab = false, announce = false) {
      if (!this.tabs.length || !this.panels.length) return;
      const nextIndex = Math.min(Math.max(index, 0), this.tabs.length - 1);
      this.activeIndex = nextIndex;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === nextIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === nextIndex;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          const track = panel.querySelector('[data-custom-featured-products]');
          if (track) track.scrollLeft = 0;
        }
      });

      if (focusTab) this.tabs[nextIndex].focus();
      if (announce && this.status) this.status.textContent = `${this.tabs[nextIndex].textContent.trim()} products shown`;
      window.requestAnimationFrame(() => this.updateArrows());
    }

    getScrollStep(track) {
      const card = track.querySelector('.custom-featured-collection__product-item');
      if (!card) return track.clientWidth;
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    updateArrows() {
      this.panels.forEach((panel) => {
        if (!panel.hidden) this.updatePanelArrows(panel);
      });
    }

    updatePanelArrows(panel) {
      const track = panel.querySelector('[data-custom-featured-products]');
      if (!track || !this.sliderControls || !this.previous || !this.next) return;

      const itemCount = track.querySelectorAll('.custom-featured-collection__product-item').length;
      const overflow = track.scrollWidth - track.clientWidth > 4;
      const hasSlider = itemCount > 4 && overflow;
      this.sliderControls.classList.toggle('has-overflow', hasSlider);
      this.previous.disabled = !hasSlider || track.scrollLeft <= 2;
      this.next.disabled = !hasSlider || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
  });
}
